import * as React from 'react';
import * as honoraryNoteLogic from '../../../../business/logic/honorary-note-logic';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { newHonoraryNote, selectHonoraryNote } from '../../../../store/details/honorary-note/actions';

import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import { Dispatch } from 'redux';
import { HonoraryNote } from '../../../../store/details/honorary-note/types';
import { connect } from 'react-redux';
import styles from './honorary-note-list.module.css';

interface PropsFromDispatch {
  readonly newHonoraryNote: typeof newHonoraryNote;
  readonly selectHonoraryNote: typeof selectHonoraryNote;
}

interface PropsFromState {
  readonly selectedHonoraryNoteId: number;
  readonly honoraryNotes: HonoraryNote[];
  readonly caseBlocked: boolean;
  readonly instructionId: number;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class HonoraryNoteList extends React.Component<AllProps> {
  render() {
    const isSelectedItem = (item: HonoraryNote) => item.honoraryNoteId === this.props.selectedHonoraryNoteId;
    const isLockedItem = (item: HonoraryNote) => item.locked || this.props.caseBlocked;

    const getBorderClass = (item: HonoraryNote) => {
      if (isSelectedItem(item)) {
        return styles.borderActive;
      }
      if (isLockedItem(item)) {
        return styles.borderLocked;
      }
      return styles.border;
    };

    const getBackroundClass = (item: HonoraryNote) => {
      if (isLockedItem(item)) {
        return styles.backgroundLocked;
      }
      return '';
    };

    const itemList = this.props.honoraryNotes.map(item => {
      return (
        <div key= {item.honoraryNoteId} className={`${styles.item} ${getBorderClass(item)} ${getBackroundClass(item)}`} onClick={() => {
          this.props.selectHonoraryNote(item.honoraryNoteId);
        }}>
          <div className={styles.tabIndicatorRow}>
                <div className={styles.tabIndicatorRowSpacer}>{item.honoraryNoteId}</div>
           </div>
          <div className={styles.tabIndicatorTotalRow}>
            <BelfiusCurrencyText
              value={honoraryNoteLogic.getTotal(item.honoraryNoteLines)}
              prefix=' €' />
          </div>
        </div>
      );
    }
    );

    return (
      <div className={styles.container}>
        <div className={styles.itemRow}>
          {itemList}
        </div>
        <div className={styles.buttonContainer}>
          <div className={styles.addButton} onClick={() => {
              if (this.props.caseBlocked) { return; }
              this.props.newHonoraryNote(this.props.instructionId); }} >
            <img alt="" src={require('../../../../assets/images/add_85x85.png')} />
          </div>
        </div>
      </div >
    );
  }
}

const mapStateToProps = ({ details: { detailsHonoraryNote }, caseState: { selectedCase } }: ApplicationState): PropsFromState => ({
  honoraryNotes: detailsHonoraryNote.honoraryNotes,
  selectedHonoraryNoteId: detailsHonoraryNote.selectedHonoraryNote.honoraryNoteId,
  caseBlocked: selectedCase.blocked,
  instructionId: selectedCase.instructionId,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  newHonoraryNote: (instructionId: number) => dispatch(newHonoraryNote(instructionId)),
  selectHonoraryNote: (honoraryNoteId: number) => dispatch(selectHonoraryNote(honoraryNoteId))
});

export default connect(mapStateToProps, mapDispatchToProps)(HonoraryNoteList);
